import './index.css';

import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import App from './App';
import { reloadOnceForStaleBuild } from './lib/chunk-reload';
import store from './store/configureStore';

// Vite fires this when a module preload 404s (a tab outliving a deploy). preventDefault stops the
// rejection only once a reload is under way; otherwise the error reaches the ErrorBoundary.
window.addEventListener('vite:preloadError', (event) => {
	if (reloadOnceForStaleBuild()) event.preventDefault();
});

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
	<Provider store={store()}>
		<HelmetProvider>
			<ToastContainer
				limit={1}
				className='erms_toast'
			/>

			<App />
		</HelmetProvider>
	</Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
